export interface BaseEntity {
    // using type any to avoid methods complaining of invalid type
    id?: string|number;
};